import WvContactUsForm from "~/components/organisms/WvContactUsForm";
import type { ContactUsFormSliceFullPage } from "~/lib/prismic/types.generated";
import { asLink, asText } from "@prismicio/helpers";
import type { HTMLComponent } from "../../../../../../../../libs/react/src/lib/types";
import { linkResolver } from "~/lib/prismic/utils";

const ContactUsFormFullPage: HTMLComponent<{
  slice: ContactUsFormSliceFullPage;
}> = ({ slice }) => {
  return (
    <div className="component__contact">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12">
            <WvContactUsForm
              title={asText(slice.primary.title)}
              linkToAfterSubmit={
                asLink(slice.primary.linktoaftersubmit, linkResolver) || ""
              }
              captchaSiteKey={asText(slice.primary.captcha_site_key)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsFormFullPage;
